import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["for", "onKeyup"]
const _hoisted_3 = ["id", "name", "disabled", "value", "onChange"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "RadioButton_checkWrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "RadioButton_check" })
], -1)
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelComponent = _resolveComponent("LabelComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["", [
			'text-left RadioButton__container',
			{ 'RadioButton--alternateReadonlyPresentation': _ctx.alternateReadonlyPresentation },
		]]),
    disabled: _ctx.alternateReadonlyPresentation
  }, [
    _createVNode(_component_LabelComponent, {
      label: _ctx.label,
      tooltip: _ctx.tooltip,
      isHtmlLabel: false,
      readonly: _ctx.disabled
    }, null, 8, ["label", "tooltip", "readonly"]),
    (!!_ctx.readonlyValue)
      ? (_openBlock(), _createBlock(_component_inputFieldComponent, {
          key: 0,
          id: _ctx.id,
          readonlyValue: _ctx.readonlyValue
        }, null, 8, ["id", "readonlyValue"]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.options, (item, inx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: _ctx.id + inx
          }, [
            _createElementVNode("label", {
              class: "RadioButton",
              for: _ctx.id + item,
              tabindex: "0",
              onKeyup: [
                _withKeys(($event: any) => (_ctx.changeItem(item)), ["enter"]),
                _withKeys(($event: any) => (_ctx.changeItem(item)), ["space"])
              ]
            }, [
              _withDirectives(_createElementVNode("input", {
                id: _ctx.id + item,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.change) = $event)),
                class: "RadioButton_input",
                type: "radio",
                name: _ctx.name,
                disabled: _ctx.disabled,
                value: item,
                onChange: ($event: any) => (_ctx.emitChange(item))
              }, null, 40, _hoisted_3), [
                [_vModelRadio, _ctx.change]
              ]),
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.labels[inx]), 1)
            ], 40, _hoisted_2)
          ]))
        }), 128)),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          role: "alert",
          class: "RadioButton__error",
          textContent: _toDisplayString(_ctx.validationErrorText)
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}